import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
import create from "../../create";
export default create({
  name: "bar",
  computed: {
    x2: function x2() {
      return this.option.gridX2 || 20;
    }
  },
  methods: {
    updateChart: function updateChart() {
      var _this = this;

      var optionData = this.deepClone(this.dataChart);
      var option = {
        title: this.ishasprop(this.option.titleShow, {
          text: this.option.title,
          subtext: this.option.subtext || '',
          textStyle: {
            color: this.option.titleColor || '#333',
            fontSize: this.option.titleFontSize || 16
          },
          left: this.option.titlePostion || 'auto',
          subtextStyle: {
            color: this.option.subTitleColor || '#aaa',
            fontSize: this.option.subTitleFontSize || 14
          }
        }, {}),
        tooltip: this.ishasprop(this.formatter, {
          formatter: function formatter(name) {
            return _this.formatter(name, _this.dataChart);
          }
        }, {
          textStyle: {
            fontSize: this.option.tipFontSize,
            color: this.option.tipColor || "#fff"
          }
        }),
        grid: {
          left: this.option.gridX || 20,
          top: this.option.gridY || 60,
          right: this.x2,
          bottom: this.option.gridY2 || 60
        },
        legend: {
          show: this.vaildData(this.option.legend, false),
          orient: this.option.legendOrient || "vertical",
          x: this.option.legendPostion || "left",
          top: 0,
          right: this.x2,
          textStyle: {
            fontSize: this.option.legendFontSize || 12
          },
          data: function () {
            return (optionData.series || []).map(function (ele, index) {
              return {
                name: ele.name,
                textStyle: _this.ishasprop(!_this.switchTheme, {
                  color: _this.getColor(index, true)
                }, {})
              };
            });
          }()
        },
        xAxis: {
          type: this.option.category ? "value" : "category",
          name: this.option.xAxisName,
          axisLine: {
            lineStyle: {
              color: this.option.lineColor || "#333"
            }
          },
          data: optionData.categories || [],
          inverse: this.vaildData(this.option.xAxisInverse, false),
          show: this.vaildData(this.option.xAxisShow, true),
          splitLine: {
            show: this.vaildData(this.option.xAxisSplitLineShow, false)
          },
          axisLabel: {
            interval: this.option.xAxisinterval || 'auto',
            rotate: this.option.xAxisRotate || 0,
            textStyle: {
              color: this.option.nameColor || "#333",
              fontSize: this.option.xNameFontSize || 14
            }
          }
        },
        yAxis: {
          type: this.option.category ? "category" : "value",
          name: this.option.yAxisName,
          data: optionData.categories || [],
          axisLabel: {
            textStyle: {
              color: this.option.nameColor || "#333",
              fontSize: this.option.yNameFontSize || 14
            }
          },
          axisLine: {
            lineStyle: {
              color: this.option.lineColor || "#333"
            }
          },
          inverse: this.vaildData(this.option.yAxisInverse, false),
          show: this.vaildData(this.option.yAxisShow, true),
          splitLine: {
            show: this.vaildData(this.option.yAxisSplitLineShow, true)
          }
        },
        series: function () {
          var barColor = _this.option.barColor || [];
          var list = (optionData.series || []).map(function (ele, index) {
            return Object.assign(ele, {
              type: "bar",
              stack: ele.stack,
              barWidth: _this.option.barWidth || 16,
              barMinHeight: _this.option.barMinHeight || 0,
              itemStyle: _this.ishasprop(!_this.switchTheme, {
                color: _this.getColor(index)
              }, {
                barBorderRadius: _this.option.barRadius || 0
              }),
              label: {
                show: _this.vaildData(_this.option.labelShow, false),
                //开启显示
                position: _this.option.category ? "right" : "top",
                //在上方显示,
                formatter: function formatter(name) {
                  return _this.getLabelFormatter(name);
                },
                textStyle: {
                  //数值样式
                  fontSize: _this.option.labelShowFontSize || 14,
                  color: _this.option.labelShowColor || "#333",
                  fontWeight: _this.option.labelShowFontWeight || 500
                }
              }
            });
          });
          return list;
        }()
      };
      this.myChart.resize();
      this.myChart.setOption(option, true);
    }
  }
});